import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { api, formatApiError, useAuth } from '@/App';
import { Lightning, CheckCircle, XCircle } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8ddecf7f-a4c9-427e-b02f-3053db4df717/artifacts/217o5tly_Marema_Logo.jpg";

const MagicLoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAuthUser } = useAuth();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    const processLogin = async () => {
      if (!token) {
        setStatus('error');
        setError('Invalid magic link');
        return;
      }

      try {
        const { data } = await api.post('/auth/magic-login', null, { params: { token } });
        setAuthUser(data);
        setStatus('success');
        toast.success('Welcome back!');
        
        setTimeout(() => {
          if (data.role === 'admin' || data.role === 'staff') {
            navigate('/admin');
          } else {
            navigate('/portal');
          }
        }, 1500);
      } catch (error) {
        setStatus('error');
        setError(formatApiError(error));
        toast.error(formatApiError(error));
      }
    };

    processLogin();
  }, [token, navigate, setAuthUser]);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Marema Consulting" className="h-[4.5rem] w-auto" />
          </Link>
        </div>

        <div className="bg-white border border-[#E5E7EB] p-8 shadow-sm">
          {status === 'loading' && (
            <>
              <div className="w-12 h-12 border-4 border-[#0055FF] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
              <h2 className="text-xl font-bold text-[#0A192F] mb-2">Signing you in...</h2>
              <p className="text-[#4B5563]">Please wait while we verify your magic link.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 bg-[#10B981]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-8 h-8 text-[#10B981]" weight="fill" />
              </div>
              <h2 className="text-xl font-bold text-[#0A192F] mb-2">Login Successful!</h2>
              <p className="text-[#4B5563]">Redirecting to your dashboard...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-[#EF4444]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-8 h-8 text-[#EF4444]" weight="fill" />
              </div>
              <h2 className="text-xl font-bold text-[#0A192F] mb-2">Login Failed</h2>
              <p className="text-[#4B5563] mb-6">{error}</p>
              <Link to="/login">
                <button className="bg-[#0055FF] hover:bg-[#0044CC] text-white px-6 py-3 font-medium transition-colors">
                  Back to Login
                </button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MagicLoginPage;
